import { RootState } from '@store/index'
import { CustomReportCategory } from '@utils/report-schema-helper'
import { useSelector } from 'react-redux'

export const useCustomReportCategories = (): CustomReportCategory[] => {
  const reportsTemplate = useSelector(
    (state: RootState) => state.reportsTemplate.data,
  )

  const categories = Array.from(
    new Map(
      reportsTemplate?.metricsSchema
        ?.filter((metric: any) => metric.customCategory)
        ?.map((metric: any) => [
          metric.customCategory,
          {
            id: metric.customCategory,
            label: metric.customCategoryLabel,
          },
        ]),
    ).values(),
  ) as CustomReportCategory[]

  return categories ?? []
}
